import script from "./AppLayout.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppLayout.vue?vue&type=script&lang=ts&setup=true"

import "./AppLayout.vue?vue&type=style&index=0&id=b8524736&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b8524736"]])

export default __exports__